module.exports = __webpack_public_path__ + "img/issue-icon.019cd1ec.svg";